<template>
  <div>
    <v-container fluid class="pt-0">
      <v-row class="topbanner-bg">
        <v-col cols="12">
          <v-row class="justify-center">
            <v-col cols="6" md="4" class="text-center">
                <v-img
                  aspect-ratio="2"
                  max-width="200"
                  src="./assets/logo_app_glow.png"
                  style="margin: 0 auto"
                />
            </v-col>
          </v-row>
          <v-row class="justify-center mt-5">
            <v-col cols="12" md="4">          
              <v-card v-if="subscription">
                  <v-card-title>
                    <v-spacer />
                    FANTASTICO!
                    <v-spacer />
                  </v-card-title>
                  <v-card-text class="text-center">
                    Il pagamento è andato a buon fine!<br>
                    Ora puoi goderti l'app SelfDiet!
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn rounded color="primary" class="px-4 mb-4" @click="$router.replace('/subscription')">
                      TORNA ALLA HOMEPAGE
                    </v-btn>
                    <v-spacer />
                  </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {

  data: () => ({}), 
  
  computed: {
    ...mapGetters(['getSubscription']),
    subscription() {
      return this.getSubscription
    },
  },

  methods: {
    ...mapMutations(['setSubscription'])
  },

  mounted() {
    const checkoutSessionId = this.$route.params.checkout_session_id
    if(checkoutSessionId) {
      this.$loading(true);
      this.axios
        .get(`/subscriptions/checkStripePurchase/${checkoutSessionId}`)
        .then((response) => {
          if (response.data.payment_status == 'paid') {
            this.$loading(false);
            this.setSubscription(response.data.subscriptionData);
          this.$router.replace('/subscription/success')
          }
        }).catch(() => {
          this.$loading(false)
          this.$router.replace('/subscription/failed')
        });
    }
  }

};
</script>

<style scoped>
.topbanner-bg {
  background-image: url("./assets/bg.png");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  min-height: 100vh;
}
</style>
